module.exports = __webpack_public_path__ + "img/list_6.71e4cd53.jpg";